import React, { useEffect, useRef } from "react";
import { FaArrowLeft, FaQrcode, FaRegCommentDots, FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import { useState } from "react";
import axios from "axios";
import gate from "../../../assets/svg/gateout.svg";
import clck from "../../../assets/svg/clock.svg";
import len from "../../../assets/svg/lentra.svg";
import profile from "../../../assets/svg/profile.svg";
import production from "../../../assets/svg/production.svg";
import mail from "../../../assets/svg/mail.svg";
import { getCookie } from "../../../components/getcookie";
import mobile from "../../../assets/svg/mobile.svg";
import proofphn from "../../../assets/svg/proofphn.svg";
import customer from "../../../assets/svg/customer.svg";
import vendor from "../../../assets/svg/vendor.svg";
import transport from "../../../assets/svg/transporter.svg";
import itemname from "../../../assets/svg/itemname.svg";
import Description from "../../../assets/svg/Description.svg";
import Quantity from "../../../assets/svg/Quantity.svg";
import download from "../../../assets/svg/download.svg";
import print from "../../../assets/svg/print.svg";
import nandhu from "../../../assets/svg/nandhu.svg";
import druken from "../../../assets/svg/druken.svg";
import temp from "../../../assets/svg/temp.svg";
import add from "../../../assets/svg/add.svg";
import TopBar from "../../topbar/TopBar";
import { gateOutVehicleApi, getVehicleDetailsApi } from "../vehicle-api";
import "./vehicle-view.css";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import gatedetail from "../../../assets/svg/gate-details.svg";
import QueueApproveModal from "../../modal-dialog/queue-approve-modal";
import CheckListFailedAdminModal from "../../modal-dialog/checklist-failed-admin-modal";
import GateOutModal from "../../modal-dialog/gate-out-modal";
import GenerateQRModal from "../../modal-dialog/generate-qr-modal";
import { checkListFailsUpdateApi, gateInApprovedCheckListApi, getEnabledFieldApi, getFailedCheckList, getHistoryListApi, queueStatusUpdateApi, uploadGateInOutAttachmentApi, vehicleGateInApprovedCheckListApi } from "../../visitor/visitor-api";
import { useLocation, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import visit_active from "../../../assets/svg/visitor-detail-active.svg";
import visit_inactive from "../../../assets/svg/visitor-detail-inactive.svg";
import history_active from "../../../assets/svg/history-active.svg";
import loc from "../../../assets/svg/location.svg";

import history_inactive from "../../../assets/svg/history-inactive.svg";
import visitor_entry from "../../../assets/svg/visitor-entry.svg";
import visitor_gate_in from "../../../assets/svg/gatein.svg";
import acknowledged from "../../../assets/svg/acknowledged.svg";
import gate_out from "../../../assets/svg/gateout.svg";
import queue_entry from "../../../assets/svg/queue-entry.svg";
import expiry_date from "../../../assets/svg/date.svg";
import { Container, Row, Col } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import history_approve from "../../../assets/svg/history-approve.svg";
import history_reject from "../../../assets/svg/history-reject.svg";
import Attachment from "../../../assets/svg/attachment.svg";
import Upload from "../../../assets/svg/gateoutupload.svg";
import Camera from "../../../assets/svg/gateoutcamera.svg";
import close from "../../../assets/svg/close-modal.svg";
import ownerIcon from "../../../assets/svg/owner.svg";
import locationIcon from "../../../assets/svg/location.svg";
import { validateExpiryStatus, checkIfExpired } from "../expiryDateValidation";
import ProfileImage from "../../../assets/png/customer-icon.png";
import permitIcon from "../../../assets/svg/permit_type.svg";

export default function VehicleView() {
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = location.state || {};
  const apiUrl = process.env.REACT_APP_API_URL;

  const iframeRef = useRef(null);

  const [activeTab, setActiveTab] = useState("items");
  const [loginId, setLoginId] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [vehicleDetails, setVehicleDetails] = useState({});
  const [visitorHistory, setVisitorHistory] = useState([]);
  const [showQueueApproveModal, setShowQueueApproveModal] = useState(false);
  const [showGateOutDetails, setShowGateOutDetails] = useState(false);
  const [showGenerateQRCode, setShowGenerateQRCode] = useState(false);
  const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedVisitHistory, setSelectedVisitHistory] = useState("Vehicle");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [checkList, setCheckList] = useState([]);
  const [enabledFields, setEnabledFields] = useState([]);
  useEffect(() => {
    if (id) {
      console.log("New visitor ID:", id);
      getVehicleDetails();
      getHistoryList();
      getFailedCheck();
    }
  }, [id]);
  const getVehicleDetails = async () => {
    try {
      const response = await getVehicleDetailsApi(id);
      if (response.status === true) {
        setVehicleDetails(response.vehicle ?? {});
        setLoginId(response.loginId);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEnabledField = async (id, gate_id, department_id) => {
    const data = {
      type: "Vehicle",
      gate_id: gate_id ?? "",
      department_id: department_id ?? "",
    };
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        if (response?.enabled_fields.some((item) => item === "Gate-in attachment" || item === "Invoice number" || item === "Gate-in remarks")) {
          setIsGateInAttachmentRequired(response?.mandatory_fields.some((item) => item === "Gate-in attachment") ?? false);
          setIsGateInInvoiceRequired(response?.mandatory_fields.some((item) => item === "Invoice number") ?? false);
          setIsGateInRemarksRequired(response?.mandatory_fields.some((item) => item === "Gate-in remarks") ?? false);
          openModal();
        } else {
          gateInApprovedCheckList(id);
        }
        // setEnabledFields(response?.enabled_fields ?? {});
        // setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getHistoryList = async () => {
    try {
      const response = await getHistoryListApi(id, "vehicle");
      if (response.status === true) {
        setVisitorHistory(response.history ?? []);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const printRef = useRef(null);
  /* const downloadQR = () => {
    const canvas = printRef.current.querySelector("canvas");
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = "qrcode.png";
    link.click();
  };
*/

  const downloadQR = async () => {
    try {
      const response = await axios.get(apiUrl + "vehicle_gate_pass/" + id, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: getCookie("mawalog"),
        },
      });

      const fileUrl = response.data?.url;

      if (fileUrl && fileUrl.trim() !== "") {
        const fileBlob = await axios.get(fileUrl, {
          responseType: "blob",
        });

        const blobUrl = URL.createObjectURL(fileBlob.data);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `Gatepass_${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      } else {
        const svgElement = printRef.current?.querySelector("svg");
        if (!svgElement) {
          console.error("SVG element not found inside printRef.");
          alert("QR Code not found.");
          return;
        }

        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgData], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(svgBlob);

        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const size = 800;
          canvas.width = size;
          canvas.height = size;

          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, size, size);
          ctx.drawImage(image, 0, 0, size, size);

          const pngUrl = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          downloadLink.href = pngUrl;
          downloadLink.download = `QR_${id}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(url);
        };

        image.src = url;
      }
    } catch (error) {
      console.error("Error during QR download:", error);
      alert("Something went wrong while trying to download.");
    }
  };

  const downloadQROld = () => {
    const svgElement = printRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });
    const DOMURL = window.URL || window.webkitURL || window;
    const url = DOMURL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const size = 800;
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, size, size);
      ctx.drawImage(image, 0, 0, size, size);

      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `QR_${id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    };

    image.src = url;
  };
  /* const handlePrint = useReactToPrint({
    content: () => printRef.current, // Must return a DOM element
  }); */

  const handlePrint = async () => {
    try {
      const response = await axios.get(apiUrl + "vehicle_gate_pass/" + id, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: getCookie("mawalog"),
        },
      });

      const pdfUrl = response.data?.base64;

      if (pdfUrl && pdfUrl.trim() !== "") {
        const byteCharacters = atob(pdfUrl);
        const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.src = blobUrl;
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }, 500);
        };
        document.body.appendChild(iframe);
      } else {
        if (printRef.current) {
          const printWindow = window.open("", "_blank");
          printWindow.document.write(`
          <html>
            <head><title>Print</title></head>
            <body style="display: flex; justify-content: center; align-items: center;">
              ${printRef.current.innerHTML}
            </body>
          </html>
        `);
          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
        }
      }
    } catch (error) {
      console.error("Error while printing:", error);
    }
  };
  const handlePrintOld = () => {
    console.log(printRef.current.innerHTM);
    if (printRef.current) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
          </head>
          <body style="display: flex; justify-content: center; align-items: center;">
            ${printRef.current.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };
  //modal
  const [isGateInAttachmentRequired, setIsGateInAttachmentRequired] = useState(false);
  const [gateInAttachmentRequired, setGateInAttachmentRequired] = useState("");

  const [isGateInInvoiceRequired, setIsGateInInvoiceRequired] = useState(false);
  const [gateInInvoiceRequired, setGateInInvoiceRequired] = useState("");
  const [isGateInRemarksRequired, setIsGateInRemarksRequired] = useState(false);
  const [gateInRemarksRequired, setGateInRemarksRequired] = useState("");

  const [isOpenGateInAttachment, setIsOpenGateInAttachment] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [remarks, setRemarks] = useState("");

  const openModal = () => setIsOpenGateInAttachment(true);
  const closeModal = () => setIsOpenGateInAttachment(false);
  const [imageList, setImageList] = useState([]);

  const handleUploadImageOut = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => ["image/jpeg", "image/png", "image/jpg"].includes(file.type));

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result;
        setImageList((prev) => {
          // Add only if it's not already in the list
          if (!prev.includes(base64Data)) {
            return [...prev, base64Data];
          } else {
            return prev;
          }
        });
      };
      reader.readAsDataURL(file);
    });

    e.target.value = ""; // Clear file input
  };

  //capture
  const [photoOut, setPhotoOut] = useState(false);
  const videoOutRef = useRef(null);
  const canvasOutRef = useRef(null);

  const openOutModal = () => {
    //setCapturedImageOut(null);
    setPhotoOut(true);
  };
  const closeOutModal = () => {
    stopCameraOut();
    setPhotoOut(false);
  };

  const startCameraOut = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoOutRef.current) {
        videoOutRef.current.srcObject = stream;
        videoOutRef.current.play();
      }
    } catch (err) {
      console.error("Camera access error:", err);
      alert("Please allow camera access.");
      setPhotoOut(false);
    }
  };

  const stopCameraOut = () => {
    if (videoOutRef.current && videoOutRef.current.srcObject) {
      videoOutRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoOutRef.current.srcObject = null;
    }
  };

  const captureImageOut = () => {
    const video = videoOutRef.current;
    const canvas = canvasOutRef.current;

    canvas.width = 420;
    canvas.height = 250;

    const ctx = canvas.getContext("2d");
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    const targetAspect = 420 / 250;
    const videoAspect = videoWidth / videoHeight;

    let sx, sy, sw, sh;
    if (videoAspect > targetAspect) {
      sh = videoHeight;
      sw = sh * targetAspect;
      sx = (videoWidth - sw) / 2;
      sy = 0;
    } else {
      sw = videoWidth;
      sh = sw / targetAspect;
      sx = 0;
      sy = (videoHeight - sh) / 2;
    }

    ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 420, 250);
    const imageDataURL = canvas.toDataURL("image/png");

    stopCameraOut();
    setImageList((prev) => [...prev, imageDataURL]);
    setPhotoOut(false);
  };

  useEffect(() => {
    if (photoOut) startCameraOut();
    return () => stopCameraOut();
  }, [photoOut]);

  const removeImage = (indexToRemove) => {
    setImageList((prev) => prev.filter((_, index) => index !== indexToRemove));
  };
  const onApproveQueue = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();

    getVehicleDetails();
    getHistoryList();
  };
  const onApproveQueueAndGateIn = async (response) => {
    setShowQueueApproveModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();

    getVehicleDetails();
    getHistoryList();
  };
  useEffect(() => {
    if (selectedStatus !== "") {
      setChecklistFailedAdminModal(true);
    }
  }, [selectedStatus]);
  const onApprovedCheckList = async () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("approve");
  };
  const onRejectedCheckList = () => {
    setChecklistFailedAdminModal(false);
    checkListFailsUpdate("reject");
  };
  const checkListFailsUpdate = async (status) => {
    try {
      const response = await checkListFailsUpdateApi(id, status, "vehicle");
      if (response?.data.success === true) {
        setSnackbarMessage(response?.data.message);
        setSnackbarStatus(response?.data.success);
        handleSnackbarShow();
        getVehicleDetails();
        getHistoryList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const gateInApprovedCheckList = async () => {
    try {
      const response = await vehicleGateInApprovedCheckListApi(id, "vehicle", invoiceNumber, remarks);
      if (response?.data.status === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.status);
        handleSnackbarShow();
        if (imageList.length > 0) {
          uploadAttachment(id, imageList);
        }
        closeModal();
        getVehicleDetails();
        getHistoryList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onProceedGateOut = async (itemList, selectedCustomer, reasonLabel, reasonOption, attachments, remarks) => {
    gateOut(itemList, selectedCustomer, reasonLabel, reasonOption, attachments, remarks);
  };

  const gateOut = async (itemList, selectedCustomer, reasonLabel, reasonOption, attachments, remarks) => {
    try {
      const response = await gateOutVehicleApi({
        vehicle_id: id,
        items: itemList.map((item) => ({
          item_name: DOMPurify.sanitize(item.item_name),
          quantity: DOMPurify.sanitize(item.quantity),
          description: DOMPurify.sanitize(item.description),
        })),
        customers: selectedCustomer?.filter((item) => item.value !== "").map((item) => item.value),
        attachment: attachments.length ?? 0,
        gate_out_remarks: remarks,
        reason: reasonOption?.value || "",
        reason_type: reasonLabel,
      });

      setSnackbarMessage(response?.data?.message);
      setSnackbarStatus(response?.data?.status);
      handleSnackbarShow();
      if (response?.data.status === true) {
        setShowGateOutDetails(false);

        if (attachments.length > 0) {
          uploadAttachment(id, attachments);
        }

        getVehicleDetails();
        getHistoryList();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const uploadAttachment = async (id, imageList) => {
    const response = await uploadGateInOutAttachmentApi(id, {
      type: "vehicle",
      images: imageList,
    });
    if (response.status === 200) {
      setImageList([]);
      getVehicleDetails();
    }
  };
  const HistoryIcon = ({ status }) => {
    let imageIcon;
    switch (status) {
      case "Vehicle entry":
        imageIcon = <img src={visitor_entry} alt="" />;
        break;
      case "Gate-In":
        imageIcon = <img src={visitor_gate_in} alt="" />;
        break;
      case "Acknowledgement":
        imageIcon = <img src={acknowledged} alt="" />;
        break;

      case "Gate out":
        imageIcon = <img src={gate_out} alt="" />;
        break;
      case "Queue entry":
        imageIcon = <img src={queue_entry} alt="" />;
        break;

      case "Expiry date update":
        imageIcon = <img src={expiry_date} alt="" />;
        break;

      case "Checklist approved":
      case "Checklist failed & approved":
      case "Queue approved & Gate-In":
      case "Queue approved":
        imageIcon = <img src={history_approve} alt="" />;
        break;

      case "Checklist rejected":
      case "Queue rejected":
      case "Checklist failed":
        imageIcon = <img src={history_reject} alt="" />;
        break;

      default:
        imageIcon = "";
    }

    return imageIcon;
  };

  const queueStatusUpdate = async () => {
    const payload = {
      id: vehicleDetails.id,
      status: "",
      meeting_person: 0,
      checklists: [],
      queue_status: "Rejected", // Approved, Rejected
      validate_check_list: true, // true, fasle
      check_list_status: "", //pending, approve
      type: "vehicle", // pending, approved, rejected
      items: [],
    };
    try {
      const response = await queueStatusUpdateApi(payload);
      if (response.statusCode === 400) {
      } else {
        if (response?.data.status === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.status);
          handleSnackbarShow();
          getVehicleDetails();
          getHistoryList();
        } else {
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getFailedCheck = async () => {
    try {
      const response = await getFailedCheckList(id, "Vehicle");
      if (response.success === true) {
        setCheckList(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getSafeValue = (value) => {
    return value === "" || value === null || value === undefined ? "-" : value;
  };

  return (
    <Container fluid className="main-container">
      {showQueueApproveModal && (
        <QueueApproveModal
          fromModule={"Vehicle"}
          visitorDetails={vehicleDetails}
          onApproveQueue={onApproveQueue}
          onApproveQueueAndGateIn={onApproveQueueAndGateIn}
          onCancel={() => {
            setShowQueueApproveModal(false);
          }}
        />
      )}
      {showChecklistFailedAdminModal && (
        <CheckListFailedAdminModal
          moduleId={vehicleDetails.id}
          moduleName={"Vehicle"}
          checkList={vehicleDetails.checklist ?? []}
          visitorName={vehicleDetails.driver_name}
          organization={vehicleDetails.organization}
          visitorPicture={vehicleDetails.profilephoto ?? ""}
          isSaveEnable={false}
          isApprovedEnable={selectedStatus === "Approve" ? true : false}
          onApproved={onApprovedCheckList}
          isRejectedEnable={selectedStatus === "Reject" ? true : false}
          onRejected={onRejectedCheckList}
          onCancel={() => {
            setChecklistFailedAdminModal(false);
            setSelectedStatus("");
          }}
        />
      )}
      {showGateOutDetails && (
        <GateOutModal
          moduleName={"Vehicle"}
          visitorDetails={vehicleDetails}
          onProceed={onProceedGateOut}
          onCancel={() => {
            setShowGateOutDetails(false);
          }}
        />
      )}
      {showGenerateQRCode && (
        <GenerateQRModal
          moduleName={"Vehicle"}
          visitorDetails={vehicleDetails}
          onCancel={() => {
            setShowGenerateQRCode(false);
          }}
        />
      )}
      <div style={{ width: "100vw" }}>
        <TopBar currentName="vehicle" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px 20px",
            backgroundColor: "#fff",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Left Section: Back Button, Profile Icon, Name, Company */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaArrowLeft
                onClick={() => {
                  navigate(-1);
                }}
                style={{
                  fontSize: "18px",
                  marginRight: "15px",
                  cursor: "pointer",
                }}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#2d3748",
                    color: "#fff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                >
                  {vehicleDetails.driver_name?.trim().charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="card-title">{getSafeValue(vehicleDetails.driver_name)}</div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="field-title pt-1">{getSafeValue(vehicleDetails.vehicle_number)}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{getSafeValue(vehicleDetails.vehicle_type)}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section: QR Code & Acknowledgement Buttons */}
            <div style={{ display: "flex", gap: "10px" }}>
              {vehicleDetails.queue_update === true && (
                <div className="style-justify-center">
                  <div
                    className="checklist-reject-btn style-justify-center"
                    onClick={() => {
                      queueStatusUpdate();
                    }}
                  >
                    Reject
                  </div>
                  <div
                    className="checklist-approve-btn style-justify-center"
                    onClick={() => {
                      setShowQueueApproveModal(true);
                    }}
                  >
                    Approve
                  </div>
                </div>
              )}

              {loginId !== null && vehicleDetails.responsible_person === loginId?.toString() && vehicleDetails.checklist_approve === true && (
                /* visitorDetails.check_list_status==="pending" && visitorDetails.is_check_passed===false && */ <div className="style-justify-center">
                  <div
                    className="checklist-reject-btn style-justify-center"
                    onClick={() => {
                      setSelectedStatus("Reject");
                    }}
                  >
                    Reject
                  </div>
                  <div
                    className="approve-btn style-justify-center"
                    onClick={() => {
                      setSelectedStatus("Approve");
                    }}
                  >
                    Approve
                  </div>
                </div>
              )}

              {vehicleDetails.gate_in === true && (
                <div
                  style={{
                    border: "dashed 2px #2C8C53",
                    padding: "2px",
                    borderRadius: "100px",
                  }}
                >
                  <button
                    style={{
                      border: "none",
                      backgroundColor: "#2C8C53",
                      color: "#fff",
                      padding: "6px 16px",
                      borderRadius: "20px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                      zIndex: 2,
                    }}
                    onClick={() => {
                      /* gateInApprovedCheckList(); */
                      getEnabledField(id, vehicleDetails?.gate_id, vehicleDetails?.department_id);
                    }}
                  >
                    <img src={gate} alt="" /> <span className="px-2">Gate In</span>
                  </button>
                </div>
              )}

              {vehicleDetails.in_time != null && vehicleDetails.out_time == null && vehicleDetails.schedule_status !== "Reject" && (
                <button
                  onClick={() => {
                    setShowGenerateQRCode(true);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "13.5px",
                    fontWeight: "500",
                  }}
                >
                  <FaQrcode style={{ marginRight: "5px" }} /> Generate QR
                </button>
              )}
              {vehicleDetails.acknowledged === true && (
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    fontSize: "13.5px",
                    fontWeight: "500",
                  }}
                >
                  <FaRegCommentDots style={{ marginRight: "5px" }} /> Acknowledgement
                </button>
              )}
            </div>
          </div>

          {/* Gate-in, Duration, and Gate-out Section */}
          {vehicleDetails.in_time != null && vehicleDetails.in_time !== "" && (
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px dotted #ddd",
                padding: "10px",
                borderRadius: "20px",
                position: "relative",
              }}
            >
              {/* Gate In */}
              <div
                style={{
                  border: "dashed 2px black",
                  backgroundColor: "#fff",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                Gate in :{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "13px",
                    marginLeft: "5px",
                  }}
                >
                  {getSafeValue(vehicleDetails.in_time)}
                </span>
              </div>

              {/* Dashed Connecting Line */}
              <div
                style={{
                  flexGrow: 1,
                  height: "2px",
                  borderTop: "2px dashed black",
                  margin: "0 10px",
                  position: "relative",
                  top: "0px",
                  zIndex: 1,
                }}
              ></div>

              {/* Time Duration */}
              <div
                style={{
                  backgroundColor: "#f0fff0",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #a3d9a5",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <img src={clck} alt="" />
                {vehicleDetails.duration ?? "00:00:00"}
                hrs
              </div>

              {/* Dashed Connecting Line */}
              <div
                style={{
                  flexGrow: 1,
                  height: "2px",
                  borderTop: "2px dashed black",
                  margin: "0 10px",
                  position: "relative",
                  top: "0px",
                  zIndex: 1,
                }}
              ></div>

              {/* Gate Out */}
              {vehicleDetails.gate_in === false && vehicleDetails.gate_out === true && (
                <button
                  style={{
                    border: "dashed 2px black",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                  }}
                  onClick={() => setShowGateOutDetails(true)}
                >
                  <img src={gate} alt="" /> Gate out
                </button>
              )}
              {vehicleDetails.out_time && (
                <button
                  style={{
                    border: "dashed 2px black",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    padding: "8px 20px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  {getSafeValue(vehicleDetails.out_time)}
                </button>
              )}
            </div>
          )}
        </div>
        <div className="d-flex">
          <div className="visitor-details-card mt-2">
            <div
              className="field-title"
              style={{
                padding: "14px",
                backgroundColor: "#fff",
                borderRadius: "8px" /* width: "700px", height: "889px" */,
              }}
            >
              <div className="heading-title mb-2">Visitor Details</div>

              <div className="style-justify-start py-2">
                <img src={mobile} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(vehicleDetails.mobile_number)}</span>
              </div>
              <div className="style-justify-start py-2">
                <img src={mail} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(vehicleDetails.email)}</span>
              </div>
              <div className="style-justify-start py-2" style={{ marginBottom: "40px" }}>
                <img src={loc} alt="" /> <span style={{ paddingLeft: "8px" }}>{getSafeValue(vehicleDetails.location)}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginBottom: "28px",
                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#172b4d",
                  }}
                >
                  Customer
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div>
                    <img src={customer} />
                  </div>
                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#172b4d",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "400px",
                    }}
                  >
                    {vehicleDetails.customers}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginBottom: "28px",
                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#172b4d",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "400px",
                  }}
                >
                  Vendor
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div>
                    <img src={vendor} />
                  </div>
                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#172b4d",
                    }}
                  >
                    {vehicleDetails.vendors}
                  </div>
                </div>{" "}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginBottom: "28px",
                }}
              >
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#172b4d",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "400px",
                  }}
                >
                  Transport
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div>
                    <img src={transport} />
                  </div>
                  <div
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                      color: "#172b4d",
                    }}
                  >
                    {vehicleDetails.transporters}
                  </div>
                </div>{" "}
              </div>

              <div className="heading-title mt-2 mb-2">Gate Details</div>
              <p>
                <img src={gatedetail} alt="" /> <span className="vehicle-value">{getSafeValue(vehicleDetails.gate)}</span>{" "}
              </p>

              <div className="heading-title mt-3 mb-2">Proof Details</div>
              <p>
                <img src={proofphn} alt="" /> <span className="vehicle-value">{getSafeValue(vehicleDetails.proof_value) ?? "---"}</span>{" "}
                {vehicleDetails.proof_name != null && vehicleDetails.proof_name != "" && (
                  <>
                    {" "}
                    <span className="dot-span mx-3"></span>{" "}
                    <span
                      style={{
                        backgroundColor: "#F1F2F4",
                        color: "black",
                        padding: "5px 10px",
                        borderRadius: "8px",
                        border: "none",
                        fontSize: "12px",
                      }}
                    >
                      {vehicleDetails.proof_name}
                    </span>
                  </>
                )}
              </p>
              <p fontFamily="Epilogue,sans-serif" style={{ color: "#a0a0a0" }}>
                Attachments:{vehicleDetails?.proof_attachment?.length}
              </p>
              <div
                style={{
                  /* padding: "8px", */ display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {vehicleDetails?.proof_attachment?.map((attachment, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      background: "#F7F8F9",
                      borderRadius: "10px",
                      padding: "10px",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      width: "300px",
                    }}
                  >
                    <img
                      src={attachment.file_path ?? ""}
                      alt="Aadhaar"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "12px",
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        fontSize: "14px",
                        justifyContent: "space-between  ",
                      }}
                    >
                      <span style={{ fontWeight: "bold", color: "#1D2939" }}>{attachment.file_name ?? ""}</span>
                      <span style={{ fontSize: "12px", color: "#98A2B3" }}>{attachment.file_size ?? ""}MB</span>
                    </div>
                    <a
                      href={attachment.file_path ?? ""}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#027A48",
                        fontWeight: "bold",
                        textDecoration: "none",
                      }}
                    >
                      View
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="other-details-card px-3">
            <div className="mt-2" style={{ display: "flex", gap: "8px" }}>
              <div
                onClick={() => setSelectedVisitHistory("Vehicle")}
                className="tab-btn px-3"
                style={{
                  background: selectedVisitHistory === "Vehicle" ? "#2C8C53" : "#FFFFFF",
                  color: selectedVisitHistory === "Vehicle" ? "#FFFFFF" : "#172B4D",
                }}
              >
                <img src={selectedVisitHistory === "Vehicle" ? visit_active : visit_inactive} alt="" /> Vehicle details
              </div>
              <div
                onClick={() => setSelectedVisitHistory("History")}
                className="tab-btn px-3"
                style={{
                  background: selectedVisitHistory === "History" ? "#2C8C53" : "#FFFFFF",
                  color: selectedVisitHistory === "History" ? "#FFFFFF" : "#172B4D",
                }}
              >
                <img src={selectedVisitHistory === "History" ? history_active : history_inactive} alt="" /> History
              </div>
            </div>
            {selectedVisitHistory === "Vehicle" && (
              <div>
                <div className="d-flex" style={{ gap: "10px" }}>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        /* height: "280px", */
                        borderRadius: "10px",
                        padding: "16px",
                        fontFamily: "Inter, sans-serif",
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div className="heading-title mb-2">Visit details</div>

                      <div className="sub-title mt-2 mb-1">Department</div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          gap: "8px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                            fontSize: "12px",
                            color: "#64748B",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img src={production} alt="" style={{ width: "14px", height: "14px" }} /> {getSafeValue(vehicleDetails.department)}
                        </p>
                      </div>
                      <div className="sub-title mt-2 mb-1">Invoice Number</div>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "12px",
                          color: "#64748B",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {getSafeValue(vehicleDetails.invoice_number)}
                      </p>
                      <div className="sub-title mt-2 mb-1">Gate-In Remarks</div>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "12px",
                          color: "#64748B",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {getSafeValue(vehicleDetails.gate_in_remarks)}
                      </p>
                      <div className="sub-title mt-1 mb-1">Gate-Out Remarks</div>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "12px",
                          color: "#64748B",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {getSafeValue(vehicleDetails.gate_out_remarks)}
                      </p>
                      {vehicleDetails.reason_type && vehicleDetails.reason_type.trim() !== "" && <div className="sub-title mt-2 mb-1">{vehicleDetails.reason_type}</div>}

                      {vehicleDetails.reason_type && vehicleDetails.reason_type.trim() !== "" && (
                        <p
                          style={{
                            margin: "0",
                            fontSize: "12px",
                            color: "#64748B",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {getSafeValue(vehicleDetails.reason)}
                        </p>
                      )}

                      {vehicleDetails?.attachment?.length > 0 ? (
                        <div className="sub-title mt-2 mb-1">Bill or Invoice</div>
                      ) : (
                        <div></div> // Empty div or another placeholder if needed
                      )}

                      <div
                        style={{
                          /* padding: "8px", */ display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {vehicleDetails?.attachment?.map((attachment, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              background: "#F7F8F9",
                              borderRadius: "10px",
                              padding: "10px",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              width: "300px",
                            }}
                          >
                            <img
                              src={attachment.file_path ?? ""}
                              alt="Aadhaar"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "12px",
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexGrow: 1,
                                fontSize: "14px",
                                justifyContent: "space-between  ",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color: "#1D2939",
                                }}
                              >
                                {attachment.file_name ?? ""}
                              </span>
                              <span style={{ fontSize: "12px", color: "#98A2B3" }}>{attachment.file_size ?? ""} MB</span>
                            </div>
                            <a
                              href={attachment.file_path}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#027A48",
                                fontWeight: "bold",
                                textDecoration: "none",
                              }}
                            >
                              View
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        height: "280px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "10px",
                        padding: "16px",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#fff",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div className="heading-title mb-2">QR code</div>
                      {/* <img
src={qr}
alt="QR Code"
style={{ marginBottom: "10px", borderRadius: "5px" }}
/> */}
                      <div ref={printRef} style={{ textAlign: "center" }}>
                        <QRCodeSVG value={vehicleDetails.transaction_id ?? ""} size={160} bgColor="#ffffff" fgColor="#000000" level="H" includeMargin={true} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        <button onClick={downloadQR} className="download-btn px-3">
                          <img src={download} alt="" /> Download
                        </button>
                        {/*  <>
                          <iframe ref={iframeRef} src="/mawalog.pdf" style={{ display: "none" }} title="PDF Print" />
                          <button onClick={handlePrints} className="download-btn px-3">
                            <img src={download} alt="print" /> Download
                          </button>
                        </> */}
                        <button onClick={handlePrint} className="download-btn px-3">
                          <img src={print} alt="" /> Print
                        </button>
                        {/*  <>
                          <iframe ref={iframeRef} src="/mawalog.pdf" style={{ display: "none" }} title="PDF Print" />
                          <button onClick={handlePrints} className="download-btn px-3">
                            <img src={print} alt="print" /> Print
                          </button>
                        </> */}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 other-details-inner-card">
                    <div
                      style={{
                        height: "280px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "16px",
                        padding: "16px",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div className="heading-title mb-2">Check list</div>
                      <div style={{ height: "200px", overflowY: "scroll" }}>
                        {checkList?.map((check, index) => {
                          return (
                            <div
                              style={{
                                backgroundColor: check.status === "false" ? "#ffeeee" : "#DAFFE9",
                                padding: "10px",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              {check.status === "true" && <FaCheckCircle style={{ color: "green" }} />}
                              {check.status === "false" && <FaTimesCircle style={{ color: "red" }} />}
                              <span className="visit-purpose">
                                {check.checkname ?? ""} {check.creteria === "Range" ? check.value : ""}{" "}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px" /* marginLeft:"10px",maxWidth:"75%",maxHeight:"fit-content" */,
                  }}
                >
                  {/* Box 1 */}

                  {/* Box 2 */}

                  {/* Box 3 */}

                  {/* table data */}
                  <div
                    style={{
                      background: "#FFFFFF",
                      padding: "20px",
                      borderRadius: "10px",
                      flexBasis: "90%",
                    }}
                  >
                    {/* Tabs */}
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "15px",
                        gap: "8px",
                      }}
                    >
                      <div
                        className="visit-purpose px-3"
                        style={{
                          background: "#FFFFFF",
                        }}
                      >
                        Items <span className="tab-count">{vehicleDetails?.items?.length ?? 0}</span>
                      </div>
                      {/*   <div
      onClick={() => setActiveTab("guests")}
     className="tab-btn px-3"
      style={{        
        background: activeTab === "guests" ? "#D6FFE6" : "#F8F8F8",
      }}
    >
      Guests{" "}
      <span className="tab-count"  
      >
        {vehicleDetails?.guests?.length ??0}
      </span>
    </div> */}
                    </div>

                    {/* Dynamic Content: Show Items or Guests Table */}
                    <table
                      className="guest-table-border"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        maxHeight: "fit-content",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background: "#F8F9F9",
                            textAlign: "left",
                          }}
                        >
                          <th className="guest-table-header" style={{ padding: "10px" }}>
                            <img src={itemname} alt="" /> <span style={{ paddingLeft: "8px" }}>Item Name</span>
                          </th>

                          <th
                            className="guest-table-header"
                            style={{
                              padding: "10px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <img src={Quantity} alt="" style={{ width: "16px", height: "16px" }} />
                              Quantity
                            </span>
                          </th>
                          <th className="guest-table-header" style={{ padding: "10px" }}>
                            <img src={Description} alt="" /> Description
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {vehicleDetails?.items?.map((item, index) => (
                          <tr key={"itemtable" + index} className="guest-table-border">
                            <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                              {item.item_name}
                            </td>
                            <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                              {item.quantity}
                            </td>
                            <td className="guest-table-border guest-table-row-1" style={{ padding: "10px" }}>
                              {item.description}
                              {/* {index === 1 && (
                <span style={{ color: "green", cursor: "pointer" }}>
                  ...more
                </span>
              )} */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="row col-12" style={{ display: "flex" }}>
                    {(vehicleDetails?.reg_certificate_no || vehicleDetails?.insurance_company || vehicleDetails?.permit_number) && (
                      <div className="col-12 col-md-7 mt-3">
                        <div className="vehicle-info-main-card" style={{ backgroundColor: "#FFFFFF" }}>
                          <div className="vehicle-info-header-text">VEHICLE INFO</div>

                          <div className="vehicle-main-info doc-info-card-container" style={{ background: "#F8F8F8" }}>
                            <div className="vehicle-header-row mb-1">
                              <div className="vehicle-number-section">
                                <div className="vehicle-number-large">{vehicleDetails.reg_certificate_no ?? "-"}</div>
                                <div className="vehicle-type-fuel-row">
                                  <span className="vehicle-type-text1" style={{ color: "#3253EB", whiteSpace: "nowrap" }}>
                                    {vehicleDetails?.vehicle_maker_model ?? "-"}
                                  </span>
                                  <span className="vehicle-type-separator">•</span>
                                  <span className="vehicle-type-text1" style={{ color: "#2C8C53", whiteSpace: "nowrap" }}>
                                    {vehicleDetails?.body_type ?? "-"}
                                  </span>
                                  <span className="vehicle-type-separator">•</span>
                                  <span className="fuel-badge">{vehicleDetails.fuel_type ?? "-"}</span>
                                </div>
                              </div>
                              <div className="permit-info-section">
                                <div className="permit-label">
                                  Permit : <span className="permit-number">{vehicleDetails?.permit_number ?? "-"}</span>
                                </div>

                                <div className="permit-expiry">
                                  Expiry :{" "}
                                  <span
                                    className="permit-number"
                                    style={{
                                      color: validateExpiryStatus(vehicleDetails?.permit_valid_upto).color,
                                    }}
                                  >
                                    {vehicleDetails?.permit_valid_upto ?? "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="owner-state-row" style={{ gap: "8px" }}>
                              <div className="info-with-icon info-with-icon-view">
                                <img src={ownerIcon} alt="owner" />

                                <span className="info-value">{vehicleDetails.owner_name ?? "-"}</span>
                              </div>
                              <div className="info-with-icon info-with-icon-view">
                                <img src={locationIcon} alt="location" />

                                <span className="info-value">{vehicleDetails.state ?? "-"}</span>
                              </div>
                              <div className="info-with-icon info-with-icon-view">
                                <img src={permitIcon} alt="permit" />
                                <span className="info-value">{vehicleDetails?.permit_type && vehicleDetails?.permit_type !== "undefined" ? vehicleDetails?.permit_type : "-"}</span>
                              </div>
                            </div>
                          </div>

                          <div className="docs-row">
                            <div className="doc-info-card doc-info-card-container" style={{ background: "#F8F8F8" }}>
                              <div className="doc-header">RC INFO</div>
                              <div className="doc-number">{vehicleDetails.reg_certificate_no ?? "-"}</div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                }}
                              >
                                <div className="doc-expiry">
                                  Exp. :{" "}
                                  <span
                                    style={{
                                      color: validateExpiryStatus(vehicleDetails.reg_certificate_valid).color,
                                    }}
                                  >
                                    {vehicleDetails.reg_certificate_valid ?? "-"}
                                  </span>
                                </div>
                                <div
                                  className="status-badge"
                                  style={{
                                    backgroundColor: validateExpiryStatus(vehicleDetails.reg_certificate_valid).bgColor,
                                    color: validateExpiryStatus(vehicleDetails.reg_certificate_valid).color,
                                  }}
                                >
                                  <span
                                    className="dot"
                                    style={{
                                      backgroundColor: validateExpiryStatus(vehicleDetails.reg_certificate_valid).color,
                                    }}
                                  ></span>
                                  {vehicleDetails.rc_status ?? "-"}
                                </div>
                              </div>
                            </div>

                            <div className="doc-info-card doc-info-card-container" style={{ background: "#F8F8F8" }}>
                              <div className="doc-header">INSURANCE INFO</div>
                              <div className="doc-number" title={vehicleDetails.insurance_company ?? "-"} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {vehicleDetails.insurance_company ?? "-"}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: "8px",
                                }}
                              >
                                <div className="doc-expiry">
                                  Exp. :{" "}
                                  <span
                                    style={{
                                      color: validateExpiryStatus(vehicleDetails.insurance_upto).color,
                                    }}
                                  >
                                    {vehicleDetails.insurance_upto ?? "-"}
                                  </span>
                                </div>
                                <div
                                  className="status-badge"
                                  style={{
                                    backgroundColor: validateExpiryStatus(vehicleDetails.insurance_upto).bgColor,
                                    color: validateExpiryStatus(vehicleDetails.insurance_upto).color,
                                  }}
                                >
                                  <span
                                    className="dot"
                                    style={{
                                      backgroundColor: validateExpiryStatus(vehicleDetails.insurance_upto).color,
                                    }}
                                  ></span>
                                  {validateExpiryStatus(vehicleDetails.insurance_upto).status}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {(vehicleDetails?.driver || vehicleDetails?.valid_from || vehicleDetails?.valid_upto) && (
                      <div className="col-12 col-md-5 mt-3">
                        <div className="driver-info-card" style={{ backgroundColor: "#FFFFFF" }}>
                          <div className="driver-info-header">DRIVER INFO</div>

                          <div className="driver-info-content">
                            <div className="driver-row">
                              <div className="driver-profile-section">
                                <img src={vehicleDetails.driver_image || ProfileImage} alt="Driver" className="driver-profile-image" />
                              </div>

                              <div className="driver-details-section ms-2">
                                <div className="driver-name">{vehicleDetails.driver ?? "-"}</div>
                                <div className="driver-dob">
                                  <span className="dob-label">DOB :</span>
                                  <span className="dob-value">{vehicleDetails?.driver_dob ?? ""}</span>
                                </div>
                              </div>
                            </div>

                            <div className="driver-info-row mt-2">
                              <div className="driver-info-item-card rounded-2">
                                <span className="info-item-label">Issue date :</span>
                                <span className="info-item-value">{vehicleDetails.valid_from ?? "-"}</span>
                              </div>
                              <div className="driver-info-item-card rounded-2">
                                <span className="info-item-label">Expiry date :</span>
                                <span className="info-item-value">{vehicleDetails.valid_upto ?? "-"}</span>
                              </div>
                            </div>

                            <div className={`mt-2 driver-info-item ${vehicleDetails.driver_status === "Active" ? "active-bg-value" : "inactive-bg-value"}`}>
                              <span className={`driver-status-value ${vehicleDetails.driver_status === "Active" ? "" : "inactive-value"}`}>{vehicleDetails.driver_status ?? "-"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {selectedVisitHistory === "History" && (
              <div className="mt-2 other-details-card history-card">
                <div className="heading-title mb-2 style">History : {visitorHistory.length}</div>
                {visitorHistory.map((history, index) => (
                  <Row key={"checklist" + index} className="style-justify-start-start align-items-stretch">
                    <Col sm={1} className="dotted-container">
                      <div className="history-icon">
                        <HistoryIcon status={history.status} />
                      </div>

                      {index !== visitorHistory.length - 1 && <div class="vertical-line"></div>}
                    </Col>
                    <Col sm={11}>
                      <div className="mb-3">
                        <div className="heading-title">{history.status}</div>
                        <div className="vehicle-value">{history.comment ?? ""}</div>
                        {history.user && (
                          <div>
                            <span className="history-updated-by">Updated by</span> <span className="field-title">{history.user ?? ""}</span>
                          </div>
                        )}
                        <div className="meeting-person">{history.time}</div>
                      </div>
                    </Col>
                  </Row>
                ))}
              </div>
            )}
          </div>
        </div>
        <div style={{ /* padding: "20px", */ backgroundColor: "#f5f5f5" }}>
          {/* Header Section */}

          <div style={{ display: "flex" }}>
            {/* Visitor Details Section */}
            {/* {
        activeTab ==='items'
      ? */}

            {/* <div style={{  width: "700px"}}></div> */}

            {/* } */}

            {/* Right side container */}
          </div>

          {/* Pop up */}

          {showGateOutDetails && (
            <div
              style={{
                padding: "20px",
                background: "#F7F9FC",
                borderRadius: "10px",
                width: "100%",
                maxWidth: "900px",
                margin: "auto",
                fontFamily: "Arial, sans-serif",
                position: "absolute",
                zIndex: "10",
                top: "15%",
                left: "30%",
                width: "75%",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <h2 style={{ fontSize: "18px", fontWeight: "bold" }}>Gate out</h2>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowGateOutDetails(false)}
                >
                  ✖
                </button>
              </div>

              {/* User Info */}
              <div style={{ display: "flex", gap: "20px" }}>
                {/* Left Section */}
                <div
                  style={{
                    width: "40%",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    padding: "15px",
                  }}
                >
                  {/* Profile */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <img
                      src={nandhu}
                      alt="Profile"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                      }}
                    />
                    <div>
                      <h3
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          margin: "0",
                        }}
                      >
                        Nandhu P
                      </h3>
                      <p
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          margin: "0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img src={len} alt="" />
                        Lentera Technologies Private Limited
                      </p>
                    </div>
                  </div>

                  {/* Info Badges */}
                  <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
                    <div
                      style={{
                        background: "#EBFAEB",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        minWidth: "140px",
                      }}
                    >
                      <span style={{ display: "block", color: "#217A51" }}>In time</span>
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          color: "#000",
                        }}
                      >
                        23-03-2023 05:48 PM
                      </p>
                    </div>
                    <div
                      style={{
                        background: "#EBFAEB",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        minWidth: "140px",
                      }}
                    >
                      <span style={{ display: "block", color: "#217A51" }}>Purpose of visit</span>
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          color: "#000",
                        }}
                      >
                        Business meeting
                      </p>
                    </div>
                  </div>

                  {/* Details */}
                  <div
                    style={{
                      marginTop: "15px",
                      background: "#F8FAFC",
                      padding: "15px",
                      borderRadius: "10px",
                    }}
                  >
                    <h4
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      Details
                    </h4>
                    <p>Email: sampleaddress@gmail.com</p>
                    <p>Mobile: +919876543210</p>
                    <p>Location: Chennai</p>
                    <p>Entry Gate: Main gate</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#ffffff",
                      padding: "20px",
                      borderRadius: "12px",
                      width: "300px",
                      position: "relative",
                      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                      fontFamily: "Arial, sans-serif",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: "-12px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#f5f5f5",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        color: "#5f6368",
                        fontWeight: "500",
                      }}
                    >
                      Meeting person
                    </span>
                    <img
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginRight: "12px",
                        border: "1px solid #e0e0e0",
                      }}
                      src={profile}
                      alt="Profile"
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#202124",
                          marginBottom: "2px",
                        }}
                      >
                        Emilia Jackson
                      </span>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          color: "#137333",
                          fontWeight: "500",
                        }}
                      >
                        <img
                          style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "6px",
                          }}
                          src={production}
                          alt="Briefcase Icon"
                        />
                        Production & Manufacturing
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Section */}
                <div
                  style={{
                    width: "60%",
                    background: "#fff",
                    borderRadius: "24px",
                    padding: "15px",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div>Hello</div>

                  {/* Checklist */}
                  <div
                    style={{
                      background: "#F6F7F8",
                      borderRadius: "24px",
                      padding: "20px",
                      gap: "16px",
                    }}
                  >
                    <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Check list</h4>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ color: "red", borderRadius: "12px" }}>
                        {" "}
                        <img src={druken} alt="" /> Drunken
                      </span>
                      <span style={{ color: "red", borderRadius: "12px" }}>
                        {" "}
                        <img src={druken} alt="" />
                        Have a weapon
                      </span>
                      <span style={{ color: "green", borderRadius: "12px" }}>
                        {" "}
                        <img src={temp} alt="" /> Temperature - 37°C
                      </span>
                    </div>
                  </div>
                  {/* Carrying Items */}
                  <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Carrying Items</h4>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "10px",
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#F9FAFB", textAlign: "left" }}>
                        <th style={{ padding: "10px" }}>Item Name</th>
                        <th style={{ padding: "10px" }}>Quantity</th>
                        <th style={{ padding: "10px" }}>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: "10px" }}>Laptop</td>
                        <td style={{ padding: "10px" }}>2</td>
                        <td style={{ padding: "10px" }}>ThinkPad Series - Business-oriented, durable, and known for its excellent keyboards.</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "10px" }}>Laptop</td>
                        <td style={{ padding: "10px" }}>2</td>
                        <td style={{ padding: "10px" }}>ThinkPad Series - Business-oriented, durable, and known for its excellent keyboards. IdeaPad Series - Budget-friendly...</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Buttons */}
                  <button
                    style={{
                      background: "none",
                      color: "#166534",
                      border: "1px solid #166534",
                      padding: "8px 12px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                  >
                    <img src={add} alt="" /> Add item
                  </button>

                  <button
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      padding: "14px",
                      background: "#166534",
                      color: "white",
                      fontWeight: "bold",
                      borderRadius: "30px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Proceed to gate out
                  </button>
                </div>
              </div>
            </div>
          )}
          {isOpenGateInAttachment && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: "500px",
                  height: "fit-content",
                  background: "white",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                  position: "relative",
                }}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal();
                  }}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    border: "none",
                    background: "transparent",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
                {enabledFields.some((item) => item === "Gate-in attachment") && (
                  <div>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        marginBottom: "16px",
                      }}
                    >
                      Attachment {isGateInAttachmentRequired && <span style={{ color: "#FF4444" }}>*</span>}
                    </div>
                    <div
                      style={{
                        background: "#F6F7F8",
                        borderRadius: "24px",
                        padding: "12px",
                        marginBottom: "16px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <div>
                          <img src={Attachment} style={{ width: "35px" }} />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "700",
                              fontSize: "14px",
                              color: "#172b4d",
                            }}
                          >
                            Choose image or capture image
                          </div>
                          <div
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              color: "#8790A1",
                            }}
                          >
                            JPG, PNG formats only
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#ffffff",
                            border: "1px solid #d4dde7",
                            height: "36px",
                            lineHeight: "100%",
                            borderRadius: "37px",
                            padding: "10px 16px",
                            cursor: "pointer",
                          }}
                        >
                          <img src={Upload} style={{ width: "16px" }} />
                          <span
                            style={{
                              fontWeight: "700",
                              fontSize: "13px",
                              color: "#2C8C53",
                            }}
                          >
                            Upload
                          </span>
                          <input type="file" accept=".jpg,.jpeg,.png" style={{ display: "none" }} multiple onChange={handleUploadImageOut} />
                        </label>

                        <div
                          onClick={openOutModal}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#2C8C53",
                            height: "36px",
                            lineHeight: "100%",
                            borderRadius: "37px",
                            padding: "10px 16px",
                          }}
                        >
                          <div>
                            <img src={Camera} style={{ width: "16px" }} />
                          </div>
                          <div
                            style={{
                              fontWeight: "700",
                              fontSize: "13px",
                              color: "#ffffff",
                            }}
                          >
                            Capture
                          </div>
                        </div>

                        {photoOut && (
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backgroundColor: "rgba(0, 0, 0, 0.4)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 1000,
                            }}
                          >
                            <div
                              style={{
                                width: "450px",
                                backgroundColor: "#ffffff",
                                borderRadius: "16px",
                                padding: "24px",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                position: "relative",
                                height: "fit-content",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "24px",
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "18px",
                                    color: "#2f3941",
                                  }}
                                >
                                  Take a photo to confirm Gate In
                                </div>
                                <div>
                                  <img src={close} onClick={closeOutModal} style={{ cursor: "pointer" }} />
                                </div>
                              </div>

                              <video
                                ref={videoOutRef}
                                style={{
                                  borderRadius: "8px",
                                  width: "420px",
                                  height: "250px",
                                  marginBottom: "24px",
                                  backgroundColor: "#000",
                                  objectFit: "cover",
                                }}
                              />

                              <canvas ref={canvasOutRef} width={420} height={250} style={{ display: "none" }}></canvas>
                              <button
                                onClick={captureImageOut}
                                style={{
                                  width: "100%",
                                  border: "none",
                                  borderRadius: "100px",
                                  padding: "12px 48px",
                                  backgroundColor: "#2c8c53",
                                  color: "#ffffff",
                                  fontWeight: "700",
                                  fontSize: "16px",
                                  marginBottom: "12px",
                                }}
                              >
                                Capture
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {imageList.length > 0 && (
                      <div
                        style={{
                          marginTop: "12px",
                          marginBottom: "16px",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "18px",
                        }}
                      >
                        {imageList.map((img, index) => (
                          <div key={index} style={{ position: "relative" }}>
                            <img
                              src={img}
                              alt={`Preview-${index}`}
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "6px",
                                objectFit: "cover",
                              }}
                            />
                            <div
                              onClick={() => removeImage(index)}
                              style={{
                                position: "absolute",
                                top: "-6px",
                                right: "-6px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#172b4d",
                                padding: "2px",
                                borderRadius: "1000px",
                                backgroundColor: "#ebebeb",
                              }}
                            >
                              X
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {gateInAttachmentRequired}
                    </span>
                  </div>
                )}
                {enabledFields.some((item) => item === "Invoice number") && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#172b4d",
                      }}
                    >
                      Invoice Number
                      {isGateInInvoiceRequired && <span style={{ color: "#FF4444" }}>*</span>}
                    </div>

                    <div>
                      <input
                        type="text"
                        value={invoiceNumber}
                        onChange={(event) => {
                          setInvoiceNumber(event.target.value);
                        }}
                        placeholder="Enter Invoice Number"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "1px solid #d4dde7",
                          padding: "0px 16px",
                          height: "36px",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {gateInInvoiceRequired}
                    </span>
                  </div>
                )}

                {enabledFields.some((item) => item === "Gate-in remarks") && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#172b4d",
                      }}
                    >
                      Remarks
                    </div>
                    <div>
                      <textarea
                        value={remarks}
                        onChange={(event) => {
                          setRemarks(event.target.value);
                        }}
                        placeholder="Enter Remarks"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "1px solid #d4dde7",
                          padding: "8px 16px",
                          height: "100px",
                          resize: "none",
                          fontWeight: "300",
                          fontSize: "13px",
                          color: "#172b4d",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {gateInRemarksRequired}
                    </span>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginTop: "24px",
                  }}
                >
                  <button
                    onClick={() => {
                      /*  if((isGateInAttachmentRequired===true || isGateInAttachmentRequired===false) && imageList.length>0){
                       gateInApprovedCheckList();
                     }else if(isGateInAttachmentRequired===true && imageList.length===0){
                       setGateInAttachmentRequired("Gate In Attachment Required!")
                     }else if(isGateInAttachmentRequired===false && imageList.length===0){
                       gateInApprovedCheckList();
                     } */
                      if ((isGateInAttachmentRequired === false || (isGateInAttachmentRequired === true && imageList.length > 0)) && (isGateInInvoiceRequired === false || (isGateInInvoiceRequired === true && invoiceNumber !== "")) && (isGateInRemarksRequired === false || (isGateInRemarksRequired === true && remarks !== ""))) {
                        gateInApprovedCheckList();
                      } else {
                        if (isGateInAttachmentRequired === true && imageList.length === 0) {
                          setGateInAttachmentRequired("Gate In Attachment Required!");
                        }

                        if (isGateInInvoiceRequired === true && invoiceNumber === "") {
                          setGateInInvoiceRequired("Invoice Required!");
                        }

                        if (isGateInRemarksRequired === true && remarks === "") {
                          setGateInRemarksRequired("Remarks Required!");
                        }
                      }
                    }}
                    style={{
                      border: "none",
                      borderRadius: "100px",
                      padding: "12px 20px",
                      backgroundColor: "#2c8c53",
                      color: "#ffffff",
                      fontWeight: "700",
                      fontSize: "16px",
                      cursor: "pointer",
                      height: "36px",
                      lineHeight: "100%",
                    }}
                  >
                    Gate In
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={4000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}

// Base 64 pdf download from API

// import axios from "axios";

// const DownloadBase64Pdf = () => {
//   const handlePrint = async () => {
//     try {
//       const res = await axios.get("https://your-api-url.com/pdf"); // Replace with actual URL
//       const base64String = res.data?.data; // This should be the raw base64 string of the PDF

//       // Convert base64 to Blob
//       const byteCharacters = atob(base64String);
//       const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
//       const byteArray = new Uint8Array(byteNumbers);
//       const blob = new Blob([byteArray], { type: "application/pdf" });

//       // Create a blob URL and trigger download
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.download = "gate-pass.pdf";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error("Download error:", error);
//     }
//   };

//   return (
//     <button onClick={handlePrint} className="download-btn px-3">
//       <img src="/print.svg" alt="print" /> Print
//     </button>
//   );
// };

// export default DownloadBase64Pdf;
